import Cookies from 'js-cookie'
import { Navigate, Outlet } from 'react-router-dom'

const PublicPage = () => {
  const token = Cookies.get('token')

  if (token) {
    return <Navigate to='/' replace />
  }

  return <Outlet />
}

export default PublicPage
